import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useOpenCommerceUserCreateMutation } from '@occc-app/dataAccessLayer/openCommerceUser/mutations';

import { CreateUserPage } from './CreateUserPage';

import { routeCreator } from '../utils';
import { UserFormValues } from '../types';

export const CreateUserPageContainer: React.FC = () => {
  const navigate = useNavigate();
  const onCompleted = () => navigate(routeCreator.list());

  const [userCreateMutation] = useOpenCommerceUserCreateMutation({ onCompleted });

  const userCreate = (input: UserFormValues) => {
    return userCreateMutation({
      variables: {
        input: {
          name: {
            first: input.firstName,
            last: input.lastName,
          },
          email: input.email,
          userRole: input.userRole,
        },
      },
    });
  };

  return <CreateUserPage userCreate={userCreate} />;
};
